import { cn } from "@/components/utils";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

const gridboxVariants = cva("grid", {
  variants: {
    column: {
      one: "grid-cols-1",
      two: "grid-cols-2",
      three: "grid-cols-3",
      four: "grid-cols-4",
      five: "grid-cols-5",
      six: "grid-cols-6",
    },
    reasponsive: {
      twoColumn: "grid-cols-1 sm:grid-cols-2",
      threeColumn: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
      fourColumn: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
    },
    items: {
      default: "items-start",
      center: "items-center",
      end: "items-end",
      baseline: "items-baseline",
      stretch: "items-stretch",
    },
    justify: {
      default: "justify-start",
      center: "justify-center",
      end: "justify-end",
      between: "justify-between",
      around: "justify-around",
      evenly: "justify-evenly",
    },
    gap: {
      xs: "gap-1",
      sm: "gap-2",
      md: "gap-3",
      lg: "gap-4",
    },
  },
  defaultVariants: {
    column: "one",
    items: "default",
    justify: "default",
  },
});

export interface GridboxProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof gridboxVariants> {}

const GridBox = React.forwardRef<HTMLDivElement, GridboxProps>(
  ({ className, column, reasponsive, items, justify, gap, ...props }, ref) => {
    return (
      <div
        className={cn(
          gridboxVariants({
            column,
            reasponsive,
            items,
            justify,
            gap,
            className,
          })
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

export { GridBox, gridboxVariants };
